import Vue from 'vue';
import VueRouter from "vue-router";
import Login from '@/components/Login.vue';
import Main from '@/components/backend/Main.vue';

import BusinessIndex from '@/components/backend/business/Index.vue';
import BusinessEdit from '@/components/backend/business/Update.vue';
import CarIndex from '@/components/backend/car/Index.vue';
import CarEdit from '@/components/backend/car/Update.vue';
import CarAdd from '@/components/backend/car/Add.vue';

Vue.use(VueRouter);

const routes = [
  {path: '/login', name: 'login', component: Login, meta: {needLogin: false}},
  {path: '/', component: Main, children: [
    {path: '', name: 'index', component: BusinessIndex},
    {path: 'company/:id', name: 'index.edit', component: BusinessEdit},
    {path: 'car', name: 'car', component: CarIndex},
    {path: 'car/edit/:id', name: 'car.edit', component: CarEdit},
    {path: 'car/add', name: 'car.add', component: CarAdd},
  ]}
];

const router = new VueRouter({routes});
router.beforeEach((to, from, next) => {
  // 判断是否需要登陆
  let tokenInfo = localStorage.getItem('token');
  tokenInfo = tokenInfo ? JSON.parse(tokenInfo) : null;

  if (to.name !== 'login') {
    if ((! tokenInfo) || (tokenInfo.expired_at < new Date().getTime())) {
      router.push({name: 'login'});
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;
